module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ../lodash/extend.js
// module id = 1143
// module chunks = 25